import React from 'react';

import { flagStyles } from '../settings';

const SvgEE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1488px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgEE;
